import queryClient from "api/queryClient.ts";
import { getCommissionGroupQueryOptions } from "api/TenantSlug/CommissionGroup/queryOptions.ts";
import { CommissionsTableContainer } from "components/Tables/CommissionsTable/CommissionsTableContainer.tsx";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { usePermission } from "hooks/usePermissions.ts";
import {TFunction} from "i18next";
import { COMMISSION_GROUP_USER_GROUP } from "localConstants.ts";
import { PermissionEnum } from "types/enums.ts";
import { DrawerId } from "types/models.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";
import { getAffiliateHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute(
    "/_authenticated/$tenantSlug/_layout/affiliate/_layout/commission/_layout/$commissionGroupId/"
)({
    component: AffiliateCommissionGroupPage,
    staticData: {
        permissions: [PermissionEnum.AffiliateCommissionCurrentTierView],
        showInSideMenu: false,
        label: "pages.affiliate.commission.detail.title",
    },
    loader: async ({ params, context: { t } }: { params: { commissionGroupId: string }; context: { t: TFunction } }) => {
        let breadcrumb = params.commissionGroupId;

        try {
            if (params.commissionGroupId === COMMISSION_GROUP_USER_GROUP) {
                breadcrumb = t("general.default_user_group");
            } else {
                const { commissionGroup } = await queryClient.ensureQueryData(
                    getCommissionGroupQueryOptions(params.commissionGroupId)
                );
                breadcrumb = commissionGroup.title;
            }
        } catch (e) {
            console.error(e);
        }

        return {
            breadcrumb,
        };
    },
});

/**
 * List of commissions
 * @returns
 */
function AffiliateCommissionGroupPage(): JSX.Element {
    const { commissionGroupId } = Route.useParams();
    const permissionsUtils = usePermission();

    return (
        <TenantPage
            headerNavigationItems={getAffiliateHeaderItems}
            editLink={
                permissionsUtils.hasPermission(PermissionEnum.CommissionGroupUpdate) &&
                commissionGroupId !== COMMISSION_GROUP_USER_GROUP
                    ? {
                          to: "/affiliate/commission/$commissionGroupId",
                          params: { commissionGroupId: commissionGroupId },
                          search: {
                              drawerIds: DrawerId.EditCommissionGroup,
                              "editCommissionGroup-id": commissionGroupId,
                          },
                      }
                    : null
            }
        >
            <CommissionsTableContainer
                commissionGroupId={commissionGroupId}
                editPermission={PermissionEnum.AdvertiserCommissionEdit}
                showProvisionGroups={false}
                commissionType={"User"}
            />
        </TenantPage>
    );
}
